<h2 mat-dialog-title>Add new PAP Index</h2>
<form [formGroup]="papIndexForm">
  <mat-dialog-content class="parameter-fields-container">
    @if(errorMessage){
      <div class="error-message">{{ errorMessage }}</div>
    }
    <mat-form-field>
      <mat-label>Index Name</mat-label>
      <input matInput formControlName="indexName" name="indexName"
        (input)="transformToUppercase('indexName')" />
      @if(papIndexForm.controls.indexName.hasError('maxlength')){
        <mat-error>{{ "Maximum number of characters is 50" }}</mat-error>
      } @if(papIndexForm.controls.indexName.hasError('pattern') &&
      papIndexForm.controls.indexName.value){
        <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Valid Since</mat-label>
      <input
        matInput
        [matDatepicker]="dateFromPicker"
        formControlName="dateFrom"
        name="dateFrom"
      />
      <mat-hint>DD.MM.YYYY</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateFromPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateFromPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Index Value</mat-label>
      <input matInput formControlName="indexValue" name="indexValue" />
      @if (papIndexForm.get('indexValue')?.hasError('pattern')) {
        <mat-error
          >Only numbers with optional comma and up to 2 decimal places are
          allowed</mat-error
        >
      } @if (papIndexForm.get('indexValue')?.hasError('maxlength')) {
        <mat-error>Max length is 10</mat-error>
      }
    </mat-form-field>
    <div class="fields-row-container uom-row">
      <mat-form-field appearance="fill">
        <mat-label>Currency</mat-label>
        <mat-select formControlName="currency" name="currency">
          @for (currencyName of data.currencies; track currencyName) {
            <mat-option [value]="currencyName">{{ currencyName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="uom-sep">/</div>
      <mat-form-field appearance="fill">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="unit" name="unit">
          @for (unitName of data.unitNames; track unitName) {
            <mat-option [value]="unitName">{{ unitName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!papIndexForm.valid"
      (click)="addNewIndex()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>
